import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useAppSelector } from '~/redux/hooks';
import MapBox from './components/MapBox';
import { useMapStatistic } from './hooks/useMapStatistic';

function AdminMapView() {
  const userProfile = useAppSelector((state) => state.auth.userProfile);
  const authUsername = useAppSelector((state) => state.auth.username);

  const mapStatisticUsername = useMemo(() => {
    const fromProfile = userProfile?.username?.trim();
    if (fromProfile) return fromProfile;
    if (typeof authUsername === 'string' && authUsername.trim()) {
      return authUsername.trim();
    }
    return null;
  }, [userProfile?.username, authUsername]);

  const { statisticData, isLoading, errorMessage, refetch } = useMapStatistic(mapStatisticUsername);

  return (
    <Box className='h-full min-h-[360px] overflow-hidden box-border px-[22px] pt-[22px] pb-[26px]'>
      <Box className='h-full w-full min-w-0 flex flex-col'>
        <MapBox
          variant='admin'
          statisticData={statisticData}
          isLoading={isLoading}
          errorMessage={errorMessage}
          onRetry={refetch}
        />
      </Box>
    </Box>
  );
}

export default AdminMapView;
